import tableColumnsCache from "@/utils/tableColumnsCache"

const listVersion = 2
export const listName = 'sl.website.menu'
export const listStorage = tableColumnsCache(listName, [
    {label: 'ID', name: 'id', active: true, sortable: true, ordering: 1},
    {label: 'Nome', name: 'nome', active: true, sortable: true, ordering: 2},
    {label: 'Seção', name: 'secao', active: true, sortable: true, ordering: 2},
    {label: 'Ativo', name: 'status', active: true, sortable: true, ordering: 3},
], listVersion)
